import { Fragment, useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { Box, Stack, IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import UploadImageProduct from '../../common/UploadImageProduct.component';
import SelectedItemPreview from '../../form/components/SelectedItemPreview.component';
import UpdateItem from './index';

const EditItem = ({ item, setSuccessEdit = () => {}, module }) => {
  const [open, setOpen] = useState(false);
  const [defaultValues, setDefaulValues] = useState(null);
  const [remainingFiles, setRemainingFiles] = useState({});

  const handleClose = useCallback(() => setOpen(false), []);

  const handleFileDelete = (itemId, fileId) => {
    setRemainingFiles((prev) => ({
      ...prev,
      [itemId]: (prev[itemId] || []).filter((id) => id !== fileId),
    }));
  };

  useEffect(() => {
    if (item) {
      const available = _.get(item, 'attributes.available');
      const quantity_type = _.get(item, 'attributes.quantity_type');
      const product = _.get(item, 'attributes.id_item.data');
      const productItemCategory = _.get(product, 'attributes.item_category.data');

      setDefaulValues({
        id: _.get(item, 'id'),
        quantity: _.get(item, 'attributes.quantity'),
        note: _.get(item, 'attributes.note'),
        internal_note: _.get(item, 'attributes.internal_note'),
        available: available
          ? {
            id: available,
            label: available,
          }
          : null,
        quantity_type: quantity_type
          ? {
            id: quantity_type,
            label: quantity_type,
          }
          : null,
        id_item: product
          ? {
            id: product?.id,
            label: `${product?.attributes?.mexal_code} - ${product?.attributes?.name_ITA} ${product?.attributes?.name_ENG ? `(${product?.attributes?.name_ENG})` : ''}`,
            name: `${product?.attributes?.mexal_code} - ${product?.attributes?.name_ITA} ${product?.attributes?.name_ENG ? `(${product?.attributes?.name_ENG})` : ''}`,
            mexal_code: product?.attributes?.mexal_code,
            description: product?.attributes?.description,
            category: product?.attributes?.category,
            item_category: productItemCategory
              ? {
                id: productItemCategory?.id,
                code: productItemCategory?.attributes?.code,
                description: productItemCategory?.attributes?.description,
              }
              : null,
            name_ITA: product?.attributes?.name_ITA,
            item_type_ITA: product?.attributes?.item_type_ITA,
            name_ENG: product?.attributes?.name_ENG,
            item_type_ENG: product?.attributes?.item_type_ENG,
            main_unit_measure: product?.attributes?.main_unit_measure,
            other_unit_of_measure: product?.attributes?.other_unit_of_measure,
            statistical_category: product?.attributes?.statistical_category,
            merchandise_group: product?.attributes?.merchandise_group,
            nature: product?.attributes?.nature,
            vat_rate: product?.attributes?.vat_rate,
            price: product?.attributes?.price,
            existence: product?.attributes?.existence,
            location: product?.attributes?.location,
            sub_location: product?.attributes?.sub_location,
            descriptions_in_languages:
              product?.attributes?.descriptions_in_languages,
          }
          : null,
        attachment: _.get(item, 'attributes.attachment'),
        id_list: _.get(item, 'attributes.id_list.data.id'),
        id_logbook: _.get(item, 'attributes.id_logbook.data.id'),
      });
    }
  }, [item]);

  useEffect(() => {
    if (open && item?.attributes?.attachment?.data) {
      setRemainingFiles((prev) => ({
        ...prev,
        [item.id]: item.attributes.attachment.data.map((file) => file.id),
      }));
    }
  }, [item, open]);

  return (
    <Fragment>
      <IconButton color='info' component='label' onClick={() => setOpen(true)}>
        <Edit />
      </IconButton>

      <UpdateItem
        data={defaultValues}
        setSuccessEdit={setSuccessEdit}
        module={module}
        open={open}
        handleClose={handleClose}
        remainingFiles={remainingFiles?.[item?.id]}
      >
        <Stack sx={{ width: '100%' }}>
          <Box sx={{ width: 250, maxWidth: '100%', verticalAlign: 'top' }}>
            <UploadImageProduct
              remainingFiles={remainingFiles?.[item?.id]}
              item={item}
              editable={true}
              handleFileDelete={handleFileDelete}
            />
          </Box>
          <Box sx={{ width: '100%' }}>
            <SelectedItemPreview
              watchField='id_item'
              label='Selected product details'
            />
          </Box>
        </Stack>
      </UpdateItem>
    </Fragment>
  );
};

export default EditItem;
